'use strict';

/**
 * EventRegistrations
 *
 * @type {{index: waApp.controllers.EventRegistrations.add}}
 */
waApp.controllers.EventRegistrations = {
	add: function() {
		let countryInput = $('#country-id');

		$('#company-type-id').select2({
			placeholder: countryInput.attr('placeholder'),
			allowClear: true
		});
	},
	multiAdd: function() {
		waUtils.noWrapArrowLink('.panel-agenda h3');
		waApp.controllers.EventRegistrations.add();

		let eventsLists = $('.events-lists-picker');
		eventsLists.find('i').hide('fa-check');

		$(eventsLists).on('click', 'a', function(e) {
			e.preventDefault();

			let isActive = $(this).hasClass('selected');
			let listId = $(this).data('list-id');
			let eventsCounter = $('#events-counter').val();

			if (isActive) {
				$(this).removeClass('selected');
				$(this).find('i').hide('fa-check');
				eventsCounter--;
				$('#events-counter').val(eventsCounter);
				$('#list-id-' + listId).val(null);
			} else {
				$(this).addClass('selected');
				$(this).find('i').show('fa-check');
				eventsCounter++;
				$('#events-counter-error').hide();
				$('#events-counter').val(eventsCounter);
				$('#list-id-' + listId).val(listId);
			}
		});

		eventsLists.find('input[type=hidden]').each(function(index) {
			let input = $(this);
			let val = input.val();

			if (val != '') {
				input.next('a').addClass('btn btn-default active selected');
			}
		});

		$('.select2').on('change', function() {
			$(this).valid();
		});

		$('#event-registration-multi').validate({
			ignore: [],
			errorElement: 'span',
			errorClass: 'help-block',
			rules: {
				'tos': {
					required: true,
					maxlength: 2
				}
			},
			messages: {
				events_count: 'Please choose at least one event'
			},
			highlight: function(element, errorClass) {
				$(element).addClass(errorClass);
				$(element).closest('.form-group').removeClass('has-success').addClass('has-error');
			},
			unhighlight: function(element, errorClass) {
				$(element).removeClass(errorClass);
				$(element).closest('.form-group').removeClass('has-error').addClass('has-success');
			},
			errorPlacement: function(error, element) {
				if (element.parent('.input-group').length) {
					error.insertAfter(element.parent());
				} else if (element.hasClass('select2-hidden-accessible')) {
					error.insertAfter(element.next('span'));
					element.next('span').addClass('error').removeClass('valid');
				} else {
					error.insertAfter(element);
				}
			}
		});

		$('.select2-hidden-accessible').on('change', function() {
			if ($(this).valid()) {
				$(this).next('span').removeClass('error').addClass('valid');
			}
		});
	}

};
